import { render, staticRenderFns } from "./imports_connect.vue?vue&type=template&id=528eedf5&scoped=true&"
import script from "./imports_connect.vue?vue&type=script&lang=js&"
export * from "./imports_connect.vue?vue&type=script&lang=js&"
import style0 from "./imports_connect.vue?vue&type=style&index=0&id=528eedf5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528eedf5",
  null
  
)

export default component.exports